export function supervisorsBounds(i) {
  var bounds = {
    1: [
      -118.30927051059784, 33.94572588928903, -117.71115727884373,
      34.16851806093124,
    ],
    2: [
      -118.46843853032782, 33.792541607785076, -118.17993325226617,
      34.08030469676962,
    ],
    3: [
      -118.94462118183624, 33.97826299370123, -118.29167319889115,
      34.337301746322254,
    ],
    4: [
      -118.60732485891373, 32.807909398644455, -117.91638038224393,
      34.02929644747597,
    ],
    5: [
      -118.89462295958229, 34.06365044525327, -117.64636049559425,
      34.82329656066489,
    ],
  };
  return bounds[i];
}
